import { Button } from './Button';

export const CustomerPortalBtn = () => {
  const gotoCustomerPortal = () => {
    window.open('https://resolve.shipaid.com/', '_blank');
  };
  return <Button onClick={gotoCustomerPortal}>Resolution Portal</Button>;
};
